import React from "react"
import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { GoalCardItem } from "@Components/FollowUp/Goal/GoalCardItem"
import { timeUnitConverter } from "@Utils/utils"
import { RFValue } from "react-native-responsive-fontsize"
import { Divider } from "react-native-paper"
import { View } from "react-native"
import { baseColors } from "@Constants/baseStyles"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { Spacer } from "@Components/Space"
import CustomEmptyData from "@Components/CustomEmptyData"

export const CurrentGoals = ({ skills, isDone, navigation, patientGoals, goalSkills }) => {
    const gotoDetail = (item) => navigation.navigate("GoalDetail", { goal: item })
    const selectedGoalSkill = (item) => {
        const goal = goalSkills?.find(
            (goalItem) => goalItem?.goal?.toLowerCase()?.trim() === item?.name?.toLowerCase()?.trim()
        )
        const skill = goal?.skills?.[0]?.name
        return skill ?? ""
    }

    const allGoalIds = patientGoals?.map((goal) => goal.id)
    const filteredSkillGoals = skills?.map((skill) => ({
        ...skill,
        goals: skill?.goals?.filter((goal) => allGoalIds?.includes(goal.id))
    }))

    const hasGoals = filteredSkillGoals?.length > 0

    return (
        <ContainerStackScreen style={{ padding: 0 }}>
            <CustomScrollview contentContainerStyle={{ paddingBottom: 100 }} showsVerticalScrollIndicator={false}>
                {patientGoals?.length === 0 ? (
                    <>
                        <OpenSansText fontSize={RFValue(16)} textAlign={"center"}>
                            Aucun objectif à afficher
                        </OpenSansText>
                    </>
                ) : (
                    <View>
                        {hasGoals ? (
                            filteredSkillGoals?.map((skill) => {
                                const isEmpty = skill?.goals?.length === 0

                                if (isEmpty) {
                                    return null
                                }

                                return (
                                    <View key={skill.id}>
                                        <BreeSerifText style={{ color: baseColors.orange.primary }} fontSize={20}>
                                            {skill?.name}
                                        </BreeSerifText>

                                        <Spacer />

                                        {skill?.goals?.map((item, index) => (
                                            <View key={index}>
                                                <GoalCardItem
                                                    isDone={isDone}
                                                    totalTimeValidated={item.numTimeValidation}
                                                    currentTimeValidated={item.numValidated}
                                                    numTimeValidation={item.numTimeValidation}
                                                    badge={item.axis.name.replace("Axe", "").toUpperCase()}
                                                    onPress={() => gotoDetail(item)}
                                                    subtitle={`${item?.numTimeValidation} ${timeUnitConverter(
                                                        item?.timeValidationUnit
                                                    )} pour valider cet objectif`}
                                                    description={item.name}
                                                    title={selectedGoalSkill(item)}
                                                    disabled={
                                                        item.state.name === "Terminé" ||
                                                        item.numValidated === item.numTimeValidation
                                                    }
                                                />

                                                <Divider
                                                    style={{
                                                        marginVertical: 10,
                                                        backgroundColor: baseColors.green.primary
                                                    }}
                                                />
                                            </View>
                                        ))}

                                        <Divider
                                            style={{
                                                height: 2,
                                                marginVertical: 10,
                                                backgroundColor: baseColors.orange.primary
                                            }}
                                        />

                                        <Spacer />
                                    </View>
                                )
                            })
                        ) : (
                            <CustomEmptyData />
                        )}
                    </View>
                )}
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
